import { createContext, useContext, ReactNode } from 'react';

import { useSocketConnection } from './socketConnectionProvider.hooks';
import { SocketConnectionContextValue } from './types/context';
import { SocketService } from './types/socket';

type Props = {
  children: ReactNode;
  connection: SocketService;
};

const SocketConnectionContext = createContext({} as SocketConnectionContextValue);

export const useSocketConnectionContext = () => useContext(SocketConnectionContext);

// @TODO move creating & maintaining connection logic here
export const SocketConnectionProvider = ({ children, connection }: Props) => {
  const methods = useSocketConnection({ connection });

  return (
    <SocketConnectionContext.Provider value={methods}>{children}</SocketConnectionContext.Provider>
  );
};
